import React, { FC, memo } from 'react';
import FnThumbnail from '../../../../components/elements/FnThumbnail/index';
import { DivImageBlock, DivImageDescription, DivExtendedName, DivInfo, SpanCreated } from '../../styles';
import { CREATE_DATE_FORMAT } from '../../../../constants/date';
import Moment from 'react-moment';

type TProps = {
  extendedName: string;
  createdDate: string;
  creatorUser: string | undefined;
  uri: string;
};

const SameNameItem: FC<TProps> = ({ extendedName, createdDate, creatorUser = '', uri }) => (
  <DivImageBlock>
    <FnThumbnail src={uri} className="mockup-thumbnail" isReview={false} />
    <DivImageDescription>
      <DivExtendedName>{extendedName}</DivExtendedName>
      <DivInfo>
        <SpanCreated>Created: </SpanCreated>
        <Moment format={CREATE_DATE_FORMAT} date={createdDate} /> {creatorUser ? `by ${creatorUser}` : ''}
      </DivInfo>
    </DivImageDescription>
  </DivImageBlock>
);

export default memo(SameNameItem);
